import ToggleButton from "../../02-molecules/Buttons/buttonToggle";

export default class FilterButton extends ToggleButton {
  /**
   * creates an instance of ToggleButton
   * @extends ToggleButton
   */

  constructor() {
    super("[data-js-button='filter-button']"); // call ToggleButton-Instance

    this.filterButtonSelector = "[data-js-button='filter-button']";
    this.resetButtonSelector = "[data-js-button='reset-button']";
    this.filterLinkSelector = "[data-js-link='solr-ajaxlink']";

    this.filterButtonArray = Array.from(
      document.querySelectorAll(this.filterButtonSelector)
    );

    this.resetButton = document.querySelector(this.resetButtonSelector);

    this.searchInput = document.querySelector(
      "[data-js-search-input='search-input']"
    );

    this.selectedClass = "selected";

    this.applySavedState();
    this.prepareResetButton();
    this.addSearchEventListeners(this.searchInput);
    this.defaultEvent();
  }

  toggleAriaPressed(targetButton) {
    const currentPressedValue = targetButton.getAttribute("aria-pressed");
    targetButton.setAttribute(
      "aria-pressed",
      currentPressedValue === "true" ? "false" : "true"
    );
  }

  getExpandedState(targetButton) {
    const isExpanded = targetButton.parentElement.classList.contains(
      this.selectedClass
    );

    return isExpanded;
  }

  // if the saved state of a button is expanded,
  // apply the corresponding classes and attributes after page reload
  applySavedState() {
    this.filterButtonArray.forEach(filterButton => {
      const isExpanded = this.getExpandedState(filterButton);

      if (isExpanded) {
        filterButton.classList.add(this.expandedClass);
        filterButton.setAttribute("aria-pressed", "true");
      }
    });
  }

  checkForExpanded() {
    const expandedButtonArray = this.filterButtonArray.filter(filterButton =>
      this.getExpandedState(filterButton)
    );
    return expandedButtonArray.length;
  }

  prepareResetButton() {
    if (this.checkForExpanded()) {
      this.resetButton.classList.remove(this.expandedClass);
      this.resetButton.setAttribute("aria-pressed", "false");
    }
  }

  // reset filter buttons
  resetAllFilters() {
    this.filterButtonArray.forEach(filterButton => {
      const isExpanded = this.getExpandedState(filterButton);

      if (isExpanded) {
        filterButton.classList.remove(this.expandedClass);
        filterButton.setAttribute("aria-pressed", "false");
        const ajaxLink = filterButton.parentElement.querySelector(
          "[data-js-link='solr-ajaxlink']"
        );
        ajaxLink.click();
      }
    });
  }

  addSearchEventListeners(searchInput) {
    // listen for search event on input field
    // reset all filters
    searchInput.addEventListener("search", () => {
      this.resetAllFilters();
    });

    // make array of frequent search term links
    const ajaxLinksArray = document.querySelectorAll(
      "[data-js-link='frequent-searches']"
    );

    // listen for click on search link
    ajaxLinksArray.forEach(ajaxLink => {
      ajaxLink.addEventListener("click", () => {
        this.resetAllFilters();
      });
    });

    // reset button
    const resetButton = document.querySelector(
      "[data-js-button='reset-button']"
    );

    resetButton.addEventListener("click", () => {
      this.resetAllFilters();
      this.toggleAriaPressed(resetButton);
      this.toggleClasses(resetButton);
    });
  }

  defaultEvent() {
    this.filterButtonArray = Array.from(
      document.querySelectorAll(this.filterButtonSelector)
    );

    this.filterButtonArray.forEach(filterButton => {
      filterButton.addEventListener("click", event => {
        const currentButton = event.currentTarget;
        const currentFilter = currentButton.parentElement.querySelector(
          "[data-js-link='solr-ajaxlink']"
        );
        // trigger click on corresponding filter link
        currentFilter.click();
        this.toggleAriaPressed(currentButton);
        this.toggleClasses(currentButton);
      });
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new FilterButton();
});
